import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TransactionsFilter } from '../models/TransactionsModels';

interface TransactionsStateData {
  filter: TransactionsFilter;
  bulkFilter: TransactionsFilter;
}

const initialState: TransactionsStateData = {
  filter: { filter: '', type: '', status: '' },
  bulkFilter: { filter: '', type: '', status: '' },
};

export const TransactionsSlice = createSlice({
  name: 'transactions',
  initialState,
  reducers: {
    reset: () => initialState,
    resetFilter: (state) => {
      state.filter = { ...initialState.filter, filter: state.filter.filter, type: state.filter.type };
    },
    setFilter: (state, action: PayloadAction<TransactionsFilter>) => {
      state.filter = action.payload;
    },
    removeFilter: (state, action: PayloadAction<keyof TransactionsFilter>) => {
      delete state.filter[action.payload];
    },
    resetBulk: (state) => {
      state.bulkFilter = initialState.bulkFilter;
    },
    resetBulkFilter: (state) => {
      state.bulkFilter = { ...initialState.bulkFilter, filter: state.bulkFilter.filter, type: state.bulkFilter.type };
    },
    setBulkFilter: (state, action: PayloadAction<TransactionsFilter>) => {
      state.bulkFilter = action.payload;
    },
    removeBulkFilter: (state, action: PayloadAction<keyof TransactionsFilter>) => {
      delete state.bulkFilter[action.payload];
    },
  },
});

export const {
  reset,
  resetFilter,
  setFilter,
  removeFilter,
  resetBulk,
  resetBulkFilter,
  setBulkFilter,
  removeBulkFilter,
} = TransactionsSlice.actions;

export default TransactionsSlice.reducer;
